import FrameConfig from "@lib/classes/FrameConfig";
import { getContent } from "@lib/use_content";
import {
  SendPasswordResetDocument,
  SendPasswordResetMutationResult,
  SendPasswordResetMutationVariables,
} from "@graphql/api";

interface SendPasswordResetReturn {
  success: boolean;
  errorMessage?: string;
}

export default async function sendPasswordReset(
  username: string,
): Promise<SendPasswordResetReturn> {
  const { data: contentData } = await getContent(["beErrResetpwGeneral", "beErrUsernameBad"]);

  // Generate reset passworld URL
  const frameConfig = new FrameConfig();
  let resetPasswordUrl = frameConfig.resetPasswordUrl;
  if (!resetPasswordUrl) {
    resetPasswordUrl = frameConfig.parentUrl;
    if (!resetPasswordUrl) resetPasswordUrl = window.location.href.replace("#", "");
  }
  resetPasswordUrl += (resetPasswordUrl.includes("?") ? "&" : "?") + "_bedst=1";

  const client = global.window.apolloClient;
  const mutVars: SendPasswordResetMutationVariables = { resetPasswordUrl, username };
  const result: SendPasswordResetMutationResult = await client.mutate({
    mutation: SendPasswordResetDocument,
    variables: mutVars,
  });
  const success = result.data.sendPasswordReset.success;

  let errorMessage;
  if (!success) {
    errorMessage = contentData.content.beErrResetpwGeneral;
    if (result.data.sendPasswordReset.errorType == "BAD_USERNAME") {
      errorMessage = contentData.content.beErrUsernameBad;
    }
  }

  return { errorMessage, success };
}
